import { apiCallV2, servicesAPICall } from "./api";
import { io } from "socket.io-client";

export const socket = io(process.env.REACT_APP_ENVIRONMENT == 'PROD' ? process.env.REACT_APP_BASE_API_URL : process.env.REACT_APP_BASE_API_URL_DEV, {
    auth: {
        token: localStorage.getItem("access-token") || "",
    },
});

export const callSocket = async (url, data = {}) => {
    const res = await apiCallV2(
        "POST",
        url,
        {
            ...data
        },
        localStorage.getItem("access-token")
    );
};

export const socketS2 = io(process.env.REACT_APP_ENVIRONMENT == 'PROD' ? process.env.REACT_APP_SERVICE_API_ROOT : process.env.REACT_APP_SERVICE_API_DEV_ROOT, {
    auth: {
        token: localStorage.getItem("access-token") || "",
    },
});

export const callSocketS2 = async (url, data = {}) => {
    const res = await servicesAPICall(
        "POST",
        url,
        {
            ...data
        },
        localStorage.getItem("access-token")
    );
};
